<p-tabView [activeIndex]="activeIndex" styleClass="mainMenu" class="mainMenu" (onChange)="handleChange($event)">

  <!--Cup-->
  <p-tabPanel [disabled]="permessi?.permessoCup === TipoPermesso.None" header="CUP">
    <p-tabView  [activeIndex]="0" class="smallMenu">

      <!--Dettaglio CUP-->
      <p-tabPanel  header="Dettaglio CUP">
        <p-toast></p-toast>
        <p-card id="noPaddingCard">

          <div *ngIf="!datiModelloDocumentale?.formGroup" class="text-center">
            <p-progressSpinner></p-progressSpinner>
            <div> Caricamento Cup in corso </div>
          </div>

          <div style="position: relative; min-height: 55vh;">
            <upload-file *ngIf="datiModelloDocumentale?.formGroup" nomeModello="CUP" [header]="header" [cup]="cup" [isCupInitialized]="isCupInitialized"
              [datiModelloDocumentale]="datiModelloDocumentale" [buttonAnnulla]="true" [isScenarioCup]="true"
              [permesso]="permessi?.permessoCup" [user]="user" [buttonCancella]="true"
              (save)="save($event)" (delete)="cancellazioneCup()" (close)="fineUpload($event)" (onRefreshCup)="onRefreshCup($event)"></upload-file>
          </div>
        </p-card>

        <p-dialog *ngIf="showDeletedCupDialog" header="Eliminazione CUP" [(visible)]="showDeletedCupDialog"
          [style]="{width: '50vw'}" [contentStyle]="{'overflow':'visible'}" [modal]="true" [draggable]="false">
          <div>Se elimini il CUP perderai tutti gli allegati contenuti. <br />Sei davvero certo di eliminare questo Cup?
          </div>

          <ng-template pTemplate="footer">
            <button pButton pRipple icon="pi pi-check" (click)="showDeletedCupDialog = false" label="No, torna indietro"
              class="p-button-text"></button>
            <button pButton pRipple icon="pi pi-check" (click)="deleteCup()" label="Si, elimina"
              class="p-button-danger p-button-text"></button>
          </ng-template>
        </p-dialog>

        <rbk-modal *ngIf="showCupDeletedDialog" [dialogModel]="dialogModel" (onConfirm)="onCloseMessageDeleted()"></rbk-modal>
        <rbk-modal *ngIf="showErrorCupDeletedDialog" [dialogModel]="dialogModel" (onConfirm)="showErrorCupDeletedDialog = false"></rbk-modal>

      </p-tabPanel>

      <!--Gestione Utenti-->
      <p-tabPanel *ngIf="isUtenteAbilitato"
        header="Gestione Utenti">
        <app-gestione-utenti-form [idCup]="idCup"></app-gestione-utenti-form>
      </p-tabPanel>

    </p-tabView>
  </p-tabPanel>


  <!--Progetto-->


  <!--Quadro economico-->
  <p-tabPanel [disabled]="permessi?.permessoQE === TipoPermesso.None" header="Quadro Economico">
    <div *ngIf="!cup" class="text-center">
      <p-progressSpinner></p-progressSpinner>
      <div> Caricamento Quadro Economico in corso </div>
    </div>
    <app-cup-qe *ngIf="cup" [cup]="cup" [refreshRowsQE]="refreshRowsQE" (refreshCup)="refreshCup()"
      [user]="user" [permesso]="permessi?.permessoQE"  [tipiDizionario]="tipiDizionario"></app-cup-qe>
    <!-- isnewQE-->
  </p-tabPanel>

  <!--Gare-->


  <!--Documentazione-->
  <p-tabPanel [disabled]="permessi?.permessoDocumenti === TipoPermesso.None" header="Documenti">
    <p-tabView [activeIndex]="activeIndexDocumenti" class="smallMenu" (onChange)="handleChangeDocumenti($event)">
      <p-tabPanel  header="Generali">
        <rbk-documenti [isId]="isId" [cupId]="idCup" [isRefreshTab]="isRefreshTab" [nomeTab]="NomeTab.Documenti" [tipiDizionario]="tipiDizionario"
          [cup]="cup" (onRefreshTabChange)="onRefreshTab($event)" [user]="user" [permesso]="permessi?.permessoDocumenti"></rbk-documenti>
      </p-tabPanel>
      <p-tabPanel [disabled]="permessi?.permessoDocumenti === TipoPermesso.None" header="Progetto">
        <div *ngIf="!activeTabProgetto" class="text-center">
          <p-progressSpinner></p-progressSpinner>
          <div> Caricamento Documenti Progetto in corso </div>
        </div>
        <rbk-documenti *ngIf="activeTabProgetto" [isId]="isId" [cupId]="idCup" [isRefreshTab]="isRefreshTab" [nomeTab]="NomeTab.Progetto"
          [cup]="cup" (onRefreshTabChange)="onRefreshTab($event)" [user]="user" [permesso]="permessi?.permessoDocumenti"></rbk-documenti>
      </p-tabPanel>
      <p-tabPanel [disabled]="permessi?.permessoDocumenti === TipoPermesso.None" header="Gare">
        <div *ngIf="!activeTabGare" class="text-center">
          <p-progressSpinner></p-progressSpinner>
          <div> Caricamento Documenti Gare in corso </div>
        </div>
        <rbk-documenti *ngIf="activeTabGare" [isId]="isId" [cupId]="idCup" [isRefreshTab]="isRefreshTab" [nomeTab]="NomeTab.Gara"
          [cup]="cup" (onRefreshTabChange)="onRefreshTab($event)" [user]="user" [permesso]="permessi?.permessoDocumenti"></rbk-documenti>
      </p-tabPanel>

    </p-tabView>
  </p-tabPanel>

  <!--Esecuzione-->
  <p-tabPanel header="Esecuzione" [disabled]="!idCup || !qe || !(qe && qe.detail && qe.detail.atto) || permessi?.permessoEsecuzione === TipoPermesso.None" styleClass="no-margin-top">
    <div *ngIf="!qe" class="text-center">
      <p-progressSpinner></p-progressSpinner>
      <div> Caricamento Esecuzione in corso </div>
    </div>
    <app-cup-esecuzione *ngIf="idCup && qe && cup" [qe]="qe" [idCup]="idCup" [isEsecuzioneEnable]="isEsecuzioneEnable" [tipiDizionario]="tipiDizionario"
      [cup]="cup" (sendRowImpegnate)="onReceiveRows($event)" [user]="user" [permesso]="permessi?.permessoEsecuzione"></app-cup-esecuzione>
  </p-tabPanel>

  <!--Diario-->
  <p-tabPanel [disabled]="permessi?.permessoFonti === TipoPermesso.None" header="Diario">
    <p-tabView [activeIndex]="0" class="smallMenu">
      <!--Promemoria-->
      <p-tabPanel [disabled]="permessi?.permessoPromemoria === TipoPermesso.None" header="Promemoria">
        <app-cup-promemoria *ngIf="idCup" [cupId]="idCup" [user]="user" [permesso]="permessi?.permessoPromemoria"></app-cup-promemoria>
      </p-tabPanel>
      <!--Annotazioni-->
      <p-tabPanel [disabled]="permessi?.permessoAnnotazioni === TipoPermesso.None" header="Annotazioni">
        <app-cup-annotazioni *ngIf="idCup" [cupId]="idCup" [user]="user" [permesso]="permessi?.permessoAnnotazioni"></app-cup-annotazioni>
      </p-tabPanel>
    </p-tabView>
  </p-tabPanel>

  <!--Fonti di Finanziamento-->
  <p-tabPanel [disabled]="permessi?.permessoFonti === TipoPermesso.None" header="Finanziamenti">
    <app-fonti *ngIf="idCup" [cupId]="idCup" [cup]="cup" [user]="user" [permesso]="permessi?.permessoFonti"></app-fonti>
  </p-tabPanel>

</p-tabView>
